module.exports = __webpack_public_path__ + "static/media/cards.98bbdb50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cards.svg
// module id = 193
// module chunks = 0